import styled from 'styled-components';

export const StyledDot = styled.div`
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.65);
  border-radius: 100%;
`;

export const StyledLabel = styled.div`
  display: flex;
  margin-left: 10px;
  align-items: center;
  color: rgba(0, 0, 0, 0.88);
  /* Base/14 Strong */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const StyleDotWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
